import React from 'react';
import { BookOpenIcon, FileTextIcon, ListMusicIcon, ClipboardCheckIcon, PianoIcon, GlobeIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  title: '10 Volumi Completi',
  text: '5 per la primaria, 5 per la secondaria: un percorso continuo dai 6 ai 14 anni.'
}, {
  icon: FileTextIcon,
  title: '480+ Pagine di Contenuti',
  text: 'Unità pronte, schede operative, glossari e verifiche.'
}, {
  icon: ListMusicIcon,
  title: 'Attività Passo-Passo',
  text: 'Ogni concetto spiegato e messo in pratica subito, senza improvvisare.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Verifiche e Griglie di Valutazione',
  text: 'Autovalutazione per gli studenti, soluzioni pronte per il docente.'
}, {
  icon: PianoIcon,
  title: 'Musica Pratica e Coinvolgente',
  text: 'Canto, ritmo, strumentario, ascolto guidato e progetti di classe.'
}, {
  icon: GlobeIcon,
  title: 'Repertorio Italiano e Mondiale',
  text: 'Dalla tradizione italiana alla storia della musica, fino alla musica di oggi.'
}];
export function WhatsInside() {
  return <section className="w-full bg-cream-deep px-5 py-16 sm:py-24" data-id="element-182" data-mp="37u1gkyb0wnng">
      <div className="mx-auto max-w-5xl" data-id="element-183" data-mp="3lv447fho260h">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.22em] text-orange sm:text-xs" data-id="element-184" data-mp="3ltt1lizyj4ay">
          Tutto in un unico pack
        </p>
        <h2 className="mt-4 flex items-center justify-center gap-3 text-center text-[26px] font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-185" data-mp="2u2mwsp9akifc">
          <ListMusicIcon className="h-6 w-6 flex-none text-grape sm:h-7 sm:w-7" aria-hidden="true" data-id="element-186" data-mp="2p6689ty6k21q" />
          Cosa Contiene Musica Pronta?
        </h2>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-187" data-mp="2y4rnpg8cv0ya">
          {items.map(({
          icon: Icon,
          title,
          text
        }) => <article key={title} className="grid grid-rows-[auto_auto_1fr] justify-items-center rounded-3xl border border-navy/10 bg-white p-7 text-center" data-id="element-188" data-mp="2adw250uht1zh">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-grape-tint" data-id="element-189" data-mp="9cockz1h5agu">
                <Icon className="h-5 w-5 text-grape" aria-hidden="true" data-id="element-190" data-mp="eaptbdbfgxp5" />
              </span>
              <h3 className="mt-5 text-lg font-bold text-navy" data-id="element-191" data-mp="j3j2cddxis71">{title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-192" data-mp="o2dl5fbwcgr5">{text}</p>
            </article>)}
        </div>
      </div>
    </section>;
}